import script from "./ModalWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalWindow.vue?vue&type=script&lang=ts&setup=true"

import "./ModalWindow.vue?vue&type=style&index=0&id=a488f10c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a488f10c"]])

export default __exports__